import { render, staticRenderFns } from "./OvenUsers.vue?vue&type=template&id=4d213762&"
import script from "./OvenUsers.vue?vue&type=script&lang=js&"
export * from "./OvenUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports